var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hk-ws-video",attrs:{"id":"hkWsVideo"}},[_c('div',{staticClass:"playWnd",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":`player${_vm.HKIdx}`}}),_c('div',{attrs:{"id":"player"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }